<template>
  <div :class="{ 'c-dark-theme': false, animated: false, fadeIn: true }" v-if="tank!==null">
    <!-- 탱크정보 입력폼 --------------------------------------------------------------------------------------------->
    <BRow class="mb-1" v-if="tank">
      <BCol>
        <BRow>
          <BCol sm="6">
            <BInputGroup size="sm" prepend="탱크 ID">
              <BFormInput size="sm"
                          type="text"
                          class="bg-warning"
                          id="tid"
                          :state="isValidExp(tank.tid, 'hex')&&tank.tid.length===4"
                          v-model="tank.tid"
                          maxLength="4"
                          @input="v=>(tank.tid = v.toUpperCase())"
                          />
            </BInputGroup>

            <BTooltip target="tid"
                      variant="danger"
                      type="text"
                      :show="!(isValidExp(tank.tid, 'hex')&&tank.tid.length===4)"
                      placement="auto" triggers="manual">
              16진수 4자 입력
            </BTooltip>
          </BCol>
          <BCol sm="6">
            <BInputGroup size="sm" prepend="관리그룹">
              <BFormSelect size="sm"
                           type="text"
                           id="tankType"
                           :state="tank.arCode!==''"
                           v-model="tank.arCode"
                           :options="arCodeOpts"
              />
            </BInputGroup>
          </BCol>
        </BRow>

      </BCol>
    </BRow>

    <BRow class="mb-1">
      <BCol>
        <BRow>
          <BCol>
            <BInputGroup size="sm" prepend="탱크이름">
              <BFormInput size="sm" id="tank-name"
                          v-model="tank.name"
                          maxLength="100"
                          :state="(tank.name.length>0)"/>
            </BInputGroup>
            <BTooltip target="tank-name"
                      variant="danger"
                      :show="tank.name.length===0"
                      placement="auto" :triggers="['manual']">
              탱크이름 필수 입력
            </BTooltip>
          </BCol>
          <BCol>
            <BInputGroup size="sm" prepend="탱크코드">
              <BFormInput size="sm" id="tank-code"
                          v-model="tank.tankCode"
                          maxLength="100"
                          :state="(tank.tankCode.length>0)"/>
            </BInputGroup>

            <BTooltip target="tank-code"
                      variant="danger"
                      :show="tank.tankCode.length===0"
                      placement="auto" :triggers="['manual']">
              탱크코드 ex) 3-J-C(번호-유종-지역)
            </BTooltip>



          </BCol>
        </BRow>
      </BCol>
    </BRow>

    <BRow class="mb-1">
      <BCol>
        <BRow>
          <BCol>
            <BInputGroup size="sm" prepend="탱크타입">
              <BFormSelect size="sm"
                           id="tankType"
                           :state="tank.tankType!==''"
                           v-model="tank.tankType"
                           :options="opts['TANK_TYPE']"
                           required/>
            </BInputGroup>
            <BTooltip target="tankType"
                      variant="danger"
                      :show="tank.tankType===''"
                      placement="auto" :triggers="'manual'">
              탱크타입 선택
            </BTooltip>
          </BCol>
          <BCol>
            <BInputGroup prepend="D/F 코드" size="sm">
              <BFormInput size="sm" id="dfCode" type="text"
                          v-model="tank.dfCode"
                          placeholder="Deliis/F 연동 코드"
                          maxLength="40"/>
            </BInputGroup>



          </BCol>
        </BRow>

      </BCol>
    </BRow>

    <BRow class="mb-1">
      <BCol>
        <BRow>
          <BCol>
            <BInputGroup size="sm" prepend="탱크모형" class="mb-1">
              <BFormSelect size="sm"
                           id="tankShape"
                           :state="tank.tankShape!==''"
                           v-model="tank.tankShape"
                           :options="opts['TANK_SHAPE']"
                           required/>
            </BInputGroup>
            <BTooltip target="tankShape"
                      variant="danger"
                      :show="tank.tankShape===''"
                      placement="auto" :triggers="['manual']">
              탱크모형 선택
            </BTooltip>
            {{tank.tankShape}}

            <BInputGroup size="sm" prepend="사용형태" class="mb-1">
              <BFormSelect size="sm" id="tankUse"
                           v-model="tank.tankUse"
                           :state="tank.tankUse!==''"
                           :options="opts['TANK_USE']"
              />
            </BInputGroup>
            <BTooltip target="tankUse"
                      variant="danger"
                      :show="tank.tankUse===''"
                      placement="auto" :triggers="['manual']">
              사용형태 선택
            </BTooltip>

            <BInputGroup prepend="가로(㎜)" size="sm" class="mb-1">
              <BFormInput size="sm" id="tankWidth" type="number"
                          v-model="tank.tankWidth"
                          :state="tank.tankWidth>0"/>
            </BInputGroup>

            <BInputGroup prepend="높이(㎜)" size="sm" class="mb-1">
              <BFormInput size="sm" id="tankHeight" type="number"
                          v-model="tank.tankHeight"
                          :state="tank.tankHeight>0"/>
            </BInputGroup>

            <BInputGroup size="sm" prepend="우선순위">
              <BFormInput size="sm" id="order" number v-model="tank.order"/>
            </BInputGroup>


          </BCol>
          <BCol class="text-center">
            <BImg height="160"
                  v-if="tank.tankShape!==''"
                  :src="`/img/tank/shape-${tank.tankShape}.png`"/>
          </BCol>
        </BRow>

      </BCol>
    </BRow>


    <BTableSimple class="m-0 mb-2" small>
      <BTr>
        <BTd>

          <BInputGroup prepend="저장유종" size="sm" >
            <BFormSelect size="sm"
                         id="oilCode"
                         :state="tank.oilCode!==''"
                         v-model="tank.oilCode"
                         @input="setOilTempGroup"
                         :options="opts['OIL_CODE']"
            />
          </BInputGroup>

          <BTooltip target="oilCode"
                    variant="danger"
                    :show="tank.oilCode===''"
                    placement="auto" triggers="manual">
            유종 선택
          </BTooltip>

        </BTd>
        <BTd>
          <BInputGroup prepend="표시컬러" size="sm">
            <BFormInput id="color" size="sm"
                        @click="v=>{pickerShow=!pickerShow}"
                        type="text"
                        v-model="tank.color"
                        :style="{backgroundColor: tank.color, textShadow:'1px 1px #FFFFFF'}"
            />
          </BInputGroup>
          <BTooltip target="color"
                    variant="danger"
                    :show="tank.color===''"
                    placement="auto" triggers="manual">
            탱크 컬러 선택
          </BTooltip>
          <swatches-picker id="color-pick"
                           class="small"
                           v-show="pickerShow"
                           v-model="tank.color"
                           @input="v=>{tank.color=v.hex;pickerShow=false;}"/>

        </BTd>
      </BTr>
      <BTr>
        <BTd colspan="2">
          <BInputGroup size="sm">
            <BInputGroupAppend>
              <BInputGroupText size="sm"> 용량 <BBadge variant="success" class="ml-1">GL</BBadge> </BInputGroupText>

              <BFormInput size="sm" id="tankVolumeGl"
                          type="number"
                          v-model="tank.tankVolumeGl"
                          @input="tankVolumeChange('gl')"
                          :step="1" :min="1" :max="5000000"
                          :state="tank.tankVolumeGl>0"/>

              <BInputGroupText size="sm" class="ml-2">
                용량 <BBadge variant="info" class="ml-1">L</BBadge>
              </BInputGroupText>

              <BFormInput size="sm" id="tankVolumeLtr"
                          type="number"
                          v-model="tank.tankVolume"
                          @input="tankVolumeChange('ltr')"
                          :step="1" :min="1" :max="45000000"
                          :state="tank.tankVolume>0"/>

            </BInputGroupAppend>
          </BInputGroup>

          <BTooltip target="tankWidth"
                    variant="danger"
                    :show="!tank.tankWidth"
                    placement="auto" :triggers="['manual']">
            탱크지름(㎜) 필수 입력
          </BTooltip>

          <BTooltip target="tankHeight"
                    variant="danger"
                    :show="!tank.tankHeight"
                    placement="auto" :triggers="['manual']">
            탱크높이(㎜) 필수 입력
          </BTooltip>

          <BTooltip target="tankVolumeGl"
                    variant="danger"
                    :show="!tank.tankVolumeGl"
                    placement="auto" :triggers="['manual']">
            저장용량 갤런 입력
          </BTooltip>
          <BTooltip target="tankVolumeLtr"
                    variant="danger"
                    :show="!tank.tankVolume"
                    placement="auto" :triggers="['manual']">
            저장용량 리터 입력
          </BTooltip>
        </BTd>
      </BTr>
      <BTr>
        <BTd>
          <BInputGroup prepend="저장률" size="sm" >
            <BFormInput size="sm" id="realVolRate" type="number"
                        v-model="tank.realVolRate"
                        @input="tankVolumeChange('gl')"
                        :step="0.01" :min="0.01" :max="1"
                        :state="tank.realVolRate>0"/>
            <BInputGroupAppend>
              <BInputGroupText size="sm" class="text-info font-weight-bolder" style="min-width: 120px">
                {{ toComma(Math.round(tank.tankRealVol*con.LTR2GL)) }} <BBadge variant="success" class="ml-1">GL</BBadge>
              </BInputGroupText>
            </BInputGroupAppend>
          </BInputGroup>

          <BTooltip target="realVolRate"
                    variant="danger"
                    :show="!tank.realVolRate"
                    placement="auto" :triggers="['manual']">
            저장율 95% = 0.95 입력
          </BTooltip>
        </BTd>
        <BTd>
          <BInputGroup size="sm">
            <BInputGroupAppend>
              <BInputGroupText size="sm" class="text-info" style="min-width: 120px">
                {{ toComma(Math.round(tank.tankRealVol)) }} <BBadge variant="info" class="ml-1">L</BBadge>
              </BInputGroupText>
            </BInputGroupAppend>
          </BInputGroup>
        </BTd>
      </BTr>
      <BTr>
        <BTd>
          <BInputGroup prepend="안전재고" size="sm" >
            <BFormInput size="sm" id="safetyRate" type="number"
                        v-model="tank.safetyRate"
                        @input="safetyRateChange"
                        :step="0.01" :min="0" :max="1"
                        :state="isSafetyVolumeValid"/>
            <BInputGroupAppend>
              <BInputGroupText size="sm" class="text-info font-weight-bolder" style="min-width: 120px">
                {{ toComma(Math.round(tank.safetyVolume*con.LTR2GL)) }} <BBadge variant="success" class="ml-1">GL</BBadge>
              </BInputGroupText>
            </BInputGroupAppend>
          </BInputGroup>

          <BTooltip target="safetyRate"
                    variant="danger"
                    :show="!isSafetyVolumeValid"
                    placement="auto" :triggers="['manual']">
            실용량대비 비율 0 ~ 1 입력 (예: 10% = 0.1)
          </BTooltip>
        </BTd>
        <BTd>
          <BInputGroup size="sm">
            <BInputGroupAppend>
              <BInputGroupText size="sm" class="text-info" style="min-width: 120px">
                {{ toComma(Math.round(tank.safetyVolume)) }} <BBadge variant="info" class="ml-1">L</BBadge>
              </BInputGroupText>
            </BInputGroupAppend>
          </BInputGroup>
        </BTd>
      </BTr>
      <BTr>
        <BTd colspan="2">
          <BInputGroup prepend="환산보정(L)" size="sm">
            <BFormInput size="sm" id="volRevision" type="number"
                        v-model="tank.volRevision"
                        :step="1" :min="1" :max="1000000"/>

            <BInputGroupAppend>
              <BInputGroupText class="ml-2" size="sm">재고저장(초)</BInputGroupText>

              <BFormInput size="sm" id="saveInterval" type="number"
                          v-model="tank.saveInterval"
                          :state="tank.saveInterval > 9 && tank.saveInterval < 601"
                          :step="10" :min="10" :max="600"/>

              <BInputGroupText class="ml-1" size="sm">경보로그(초)</BInputGroupText>

              <BFormInput size="sm" id="eventInterval" type="number"
                          v-model="tank.eventInterval"
                          :state="tank.eventInterval > 9 && tank.eventInterval < 601"
                          :step="10" :min="10" :max="600"/>
            </BInputGroupAppend>

          </BInputGroup>
        </BTd>
      </BTr>
      <BTr>
        <BTd>
          <BInputGroup prepend="노즐" size="sm">
            <BFormSelect size="sm"
                         id="nozType"
                         :state="tank.nozType!==''"
                         v-model="tank.nozType"
                         :options="opts['NOZ_TYPE']"
            />
            <BFormSelect size="sm"
                         id="nozSize"
                         :state="tank.nozSize!==''"
                         v-model="tank.nozSize"
                         :options="opts['NOZ_SIZE']"
            />
          </BInputGroup>
        </BTd>
        <BTd>
          <BInputGroup prepend="센서" size="sm">
            <BFormSelect size="sm"
                         id="sensorType"
                         :state="tank.sensorType!==''"
                         v-model="tank.sensorType"
                         :options="opts['SENSOR_TYPE']"
            />
          </BInputGroup>
        </BTd>

      </BTr>
    </BTableSimple>




    <BCard header="경보 임계치 설정" border-variant="info" class="mb-1" no-body>
      <div slot="header">
        <BIconExclamationDiamondFill/> 경보 임계치 설정
        <div class="card-header-actions">
          <BFormCheckbox id="eventEnable" v-model="tank.eventEnabled" switch inline>
            임계치 모니터링
          </BFormCheckbox>
        </div>
      </div>

      <BTableSimple small>
        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">고온경보(℃)</BBadge></BTd>
          <BTd>
            <BFormInput size="sm" id="fire_cs" type="number"
                        v-model="tank.thresholds.fire_cs"
                        :step="0.5" :min="0.5" :max="100"
                        :state="tank.thresholds.fire_cs>0"/>
          </BTd>
        </BTr>
        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">수분경보(㎜)</BBadge></BTd>
          <BTd>
            <BFormInput size="sm" id="water_mm" type="number"
                        v-model="tank.thresholds.water_mm"
                        :step="1" :min="1" :max="1000"
                        :state="tank.thresholds.water_mm>0"/>
          </BTd>
        </BTr>
        <BTr>
          <BTd width="20%" class="text-right">
            <BBadge class="thres-badge" style="width:100%" v-b-tooltip.hover :title="leakMessage">
              누유경보(비율)
            </BBadge>
          </BTd>
          <BTd>
            <BInputGroup size="sm" prepend="누유율">
              <BFormInput size="sm" id="leakRate" type="number"
                          v-model="tank.thresholds.leakRate"
                          @input="leakRateChange"
                          :step="0.0001" :min="0.001" :max="1"
                          :state="tank.thresholds.leakRate>0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">기준(분)</BInputGroupText>
              </BInputGroupAppend>
              <!-- 자주 쓰는 간격은 선택으로 두고, 그 외는 '사용자입력'으로 분을 직접 넣는다 -->
              <BFormSelect size="sm" id="leakIntPreset"
                           v-model="leakIntPreset"
                           :options="leakIntOptions"
                           @change="leakIntPresetChange"/>
              <BFormInput v-if="leakIntPreset==='custom'"
                          size="sm" id="leakIntMins" type="number"
                          v-model.number="tank.thresholds.leakIntMins"
                          @input="leakRateChange"
                          :step="1" :min="1" :max="43200"
                          :state="tank.thresholds.leakIntMins>0"/>
            </BInputGroup>
            <b-toast id="leakHelpToast" title="누유경보 도움말" static auto-hide>
              {{leakMessage}}
            </b-toast>
          </BTd>
        </BTr>
        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">넘침경보(비율)</BBadge></BTd>
          <BTd>
            <BInputGroup prepend="첫번째" size="sm">
              <BFormInput size="sm" id="overflowRate1" type="number"
                          v-model="tank.thresholds.overflowRate1"
                          @input="overflowRateChange(1)"
                          :step="0.01" :min="0.01" :max="1"
                          :state="tank.thresholds.overflowRate1>0"/>

              <BInputGroupAppend>
                <BInputGroupText size="sm">두번째</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size="sm" id="overflowRate2" type="number"
                          v-model="tank.thresholds.overflowRate2"
                          @input="overflowRateChange(2)"
                          :step="0.01" :min="0.01" :max="1"
                          :state="tank.thresholds.overflowRate2>0"/>
            </BInputGroup>
          </BTd>
        </BTr>
        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">넘침경보(GL)</BBadge></BTd>
          <BTd>
            <BInputGroup prepend="첫번째" size="sm">
              <BFormInput size="sm" id="overflowLtr1" type="number"
                          @input="overflowVolumeChange(1)"
                          v-model="tank.thresholds.overflowGl1"
                          :step="1" :min="1000" :max="1000000"
                          :state="tank.thresholds.overflowGl1>0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">두번째</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size="sm" id="overflowLtr2" type="number"
                          @input="overflowVolumeChange(2)"
                          v-model="tank.thresholds.overflowGl2"
                          :step="1" :min="1000" :max="1000000"
                          :state="tank.thresholds.overflowGl2>0"/>
            </BInputGroup>

            <BRow class="small text-muted text-right mb-0">
              <BCol>
                {{toComma(tank.thresholds.overflowLtr1)}} <BBadge variant="info">L</BBadge>
              </BCol>
              <BCol>
                {{toComma(tank.thresholds.overflowLtr2)}} <BBadge variant="info">L</BBadge>
              </BCol>
            </BRow>

          </BTd>
        </BTr>
        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">부족경보(비율)</BBadge></BTd>
          <BTd>
            <BInputGroup prepend="첫번째" size="sm">
              <BFormInput size="sm" id="underflowRate1" type="number"
                          v-model="tank.thresholds.underflowRate1"
                          @input="underflowRateChange(1)"
                          :step="0.01" :min="0.01" :max="1"
                          :state="tank.thresholds.underflowRate1>0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">두번째</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size="sm" id="underflowRate2" type="number"
                          v-model="tank.thresholds.underflowRate2"
                          @input="underflowRateChange(2)"
                          :step="0.01" :min="0.01" :max="1"
                          :state="tank.thresholds.underflowRate2>0"/>
            </BInputGroup>
          </BTd>
        </BTr>
        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">부족경보(GL)</BBadge></BTd>
          <BTd>
            <BInputGroup prepend="첫번째" size="sm">
              <BFormInput size="sm" id="underflowLtr1" type="number"
                          @input="underflowVolumeChange(1)"
                          v-model="tank.thresholds.underflowGl1"
                          :step="1" :min="1000" :max="1000000"
                          :state="tank.thresholds.underflowGl1>0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">두번째</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size="sm" id="underflowLtr2" type="number"
                          @input="underflowVolumeChange(2)"
                          v-model="tank.thresholds.underflowGl2"
                          :step="1" :min="1000" :max="1000000"
                          :state="tank.thresholds.underflowGl2>0"/>
            </BInputGroup>
            <BRow class="small text-muted text-right mb-0">
              <BCol>
                {{toComma(tank.thresholds.underflowLtr1)}} <BBadge variant="info">L</BBadge>
              </BCol>
              <BCol>
                {{toComma(tank.thresholds.underflowLtr2)}} <BBadge variant="info">L</BBadge>
              </BCol>
            </BRow>

          </BTd>
        </BTr>

        <BTr>
          <BTd width="20%" class="text-right"><BBadge class="thres-badge" style="width:100%">노이즈 필터</BBadge></BTd>
          <BTd>
            <BInputGroup size="sm">
              <BInputGroupAppend class="mt-1">
                <BFormCheckbox id="checkNoise" v-model="tank.checkNoise" inline>
                  사용
                </BFormCheckbox>
              </BInputGroupAppend>
              <BInputGroupAppend>
                <BInputGroupText size="sm">유위(mm)</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size="sm" id="oilNoiseLimit" type="number"
                          v-model="tank.oilNoiseLimit"
                          :step="10" :min="100" :max="100000"
                          :state="tank.oilNoiseLimit>0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">수위(mm)</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size="sm" id="wtrNoiseLimit" type="number"
                          v-model="tank.wtrNoiseLimit"
                          :step="10" :min="100" :max="100000"
                          :state="tank.wtrNoiseLimit>0"/>
            </BInputGroup>
          </BTd>
        </BTr>

      </BTableSimple>
    </BCard>


    <BCard header="경보 알람" border-variant="info" class="mb-1" no-body>
      <div slot="header">
        <BIconBellFill></BIconBellFill> 경보 설정
        <div class="card-header-actions">
          <BButton variant="danger" size="sm"  @click="applyTankAlarm">
            <strong>경보설정 적용</strong>
          </BButton>
        </div>
      </div>


      <BRow>
        <BCol class="ml-2">
          <BTableSimple small class="mb-1">
            <BTr>
              <BTd width="10%">
                <BBadge class="w-100" variant="warning">모니터링</BBadge>
              </BTd>
              <BTd class="font-weight-bold small">
                <BFormCheckbox class="ml-3" id="display" v-model="tank.display" :value="true" :unchecked-value="false" switch inline>
                  <span style="color:red">탱크 모니터링</span>
                </BFormCheckbox>
                <BFormCheckbox class="ml-2" id="alarmEnable" v-model="tank.alarm.enabled" switch inline>
                  알람 사용
                </BFormCheckbox>

              </BTd>
            </BTr>

            <BTr>
              <BTd width="10%">
                <BBadge class="w-100" variant="info">콘솔 알람</BBadge>
              </BTd>
              <BTd class="font-weight-bold small">
                <BFormCheckbox class="ml-3" id="consoleIcon" v-model="tank.alarm.console.icon" :value="true" :unchecked-value="false" switch inline>
                  알림창
                </BFormCheckbox>
                <BFormCheckbox id="consoleSound" v-model="tank.alarm.console.sound" :value="true" :unchecked-value="false" switch inline>
                  사운드
                </BFormCheckbox>
                <BFormCheckbox id="consoleTts" v-model="tank.alarm.console.tts" :value="true" :unchecked-value="false" switch inline>
                  음성
                </BFormCheckbox>

              </BTd>
            </BTr>
            <BTr>
              <BTd>
                <BBadge class="w-100" variant="danger" >경보 사용</BBadge>

              </BTd>
              <BTd class="font-weight-bold small">
                <BRow class="text-nowrap">
                  <BCol sm="4" v-for="(e,i) in tank.alarm.events" :key="i">
                    <BFormCheckbox v-model="e.enabled"
                                   class="ml-3"
                                   switch inline>
                      {{ eventMap[e.code] }}
                    </BFormCheckbox>
                  </BCol>
                </BRow>
                <BRow>
                  <BCol class="text-right">

                  </BCol>
                </BRow>

              </BTd>
            </BTr>
            <BTr>
              <BTd>
                <BBadge class="w-100" variant="primary">경광등 알람</BBadge>
              </BTd>
              <BTd class="font-weight-bold small">
                <BFormCheckbox class="ml-3" id="lamp" v-model="tank.alarm.lamp.light" switch inline>
                  램프
                </BFormCheckbox>
                <BFormCheckbox id="lampBuzzer" v-model="tank.alarm.lamp.buzzer" switch inline>
                  부저
                </BFormCheckbox>
              </BTd>
            </BTr>
            <BTr>
              <BTd>
                <BBadge class="w-100" variant="warning">알림톡/SMS</BBadge>
              </BTd>
              <BTd class="font-weight-bold small">
                <BFormCheckbox class="ml-3" id="noticeAt" v-model="tank.alarm.notice.at" switch inline>
                  알림톡
                </BFormCheckbox>
                <BFormCheckbox id="noticeSms" v-model="tank.alarm.notice.sms" switch inline>
                  SMS
                </BFormCheckbox>
                <span v-if="globalNoticeOffText" class="text-danger ml-3">
                  <BIconExclamationTriangleFill class="mr-1"/>{{ globalNoticeOffText }}
                </span>
                <BBadge class="ml-3" variant="info"
                        style="cursor:pointer; font-size:0.8rem; padding:0.3em 0.5em"
                        v-b-tooltip.hover title="클릭하면 전송대상자 리스트를 표시합니다"
                        v-b-modal.notice-target-modal>
                  대상자 {{ noticeTargets.length }}명
                </BBadge>
              </BTd>
            </BTr>
          </BTableSimple>

        </BCol>
      </BRow>
    </BCard>

    <BCard header="위치정보 설정" border-variant="info" class="mb-1" no-body>
      <div slot="header" v-b-toggle.position-config>
        <BIconPinMapFill></BIconPinMapFill> 위치정보
        <div class="card-header-actions small">
          <BButton class="small" size="sm" variant="info" @click="savePosition">위치정보 적용</BButton>
        </div>
      </div>

      <b-collapse id="position-config">
        <BRow class="mt-1">
          <BCol>
            <BInputGroup prepend="GPS 위치" size="sm">
              <BInputGroupAppend class="ml-2">
                <BInputGroupText size="sm">경도(X)</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankLocationX" size="sm" type="number"
                          v-model="tank.location.coordinates[0]"
                          :state="tank.location.coordinates[0]!==0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">위도(Y)</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankLocationY" size="sm" type="number"
                          v-model="tank.location.coordinates[1]"
                          :state="tank.location.coordinates[1]!==0"/>
            </BInputGroup>
          </BCol>
        </BRow>
        <BRow>
          <BCol>
            <BInputGroup prepend="Map 위치" size="sm">
              <BInputGroupAppend class="ml-2">
                <BInputGroupText size="sm">X</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionX" size="sm" type="number"
                          v-model="tank.position.x"
                          :state="tank.position.x!==0"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">Y</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionY" size="sm" type="number"
                          v-model="tank.position.y"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">Z</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionZ" size="sm" type="number"
                          v-model="tank.position.z"
                          :state="tank.position.z!==0"/>
            </BInputGroup>
            <BInputGroup prepend="Map 조정" size="sm">
              <BInputGroupAppend class="ml-2">
                <BInputGroupText size="sm">X</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionAX" size="sm" type="number" v-model="tank.position.ax"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">Y</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionAY" size="sm" type="number" v-model="tank.position.ay"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">Z</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionAZ" size="sm" type="number" v-model="tank.position.az"/>
            </BInputGroup>
            <BInputGroup prepend="CAM 조정" size="sm" class="mt-1">
              <BInputGroupAppend class="ml-2">
                <BInputGroupText size="sm">X</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionCX" size="sm" type="number" v-model="tank.position.cx"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">Y</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionCY" size="sm" type="number" v-model="tank.position.cy"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">Z</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionCZ" size="sm" type="number" v-model="tank.position.cz"/>
            </BInputGroup>
            <BInputGroup prepend="라벨 조정" size="sm" class="mt-1">
              <BInputGroupAppend class="ml-2">
                <BInputGroupText size="sm">높이(Y)</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionLBY" size="sm" type="number" v-model="tank.position.ly"/>
              <BInputGroupAppend>
                <BInputGroupText size="sm">표시각(angle)</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput id="tankPositionLBD" size="sm" type="number" v-model="tank.position.lyd"/>

            </BInputGroup>
          </BCol>
        </BRow>
      </b-collapse>
    </BCard>

    <BCard border-variant="info" class="mb-1" no-body>
      <div slot="header">
        <BIconSpeedometer></BIconSpeedometer>표시단위 설정
        <div class="card-header-actions">
          <BInputGroup class="small">
            <BInputGroupAppend>
              <BFormSelect size="sm"
                           prepend="부피 표시 단위"
                           id="unitOfVol"
                           v-model="tank.unitOfVol"
                           :options="con.unitVolDisplayOpts"
              />
            </BInputGroupAppend>
            <BInputGroupAppend>
              <BFormSelect size="sm"
                           prepend="길이 표시 단위"
                           id="unitOfLen"
                           v-model="tank.unitOfLen"
                           :options="con.unitLenOpts"
              />
            </BInputGroupAppend>
            <BInputGroupAppend>
              <BFormSelect size="sm"
                           prepend="온도 표시 단위"
                           id="unitOfTmp"
                           v-model="tank.unitOfTmp"
                           :options="con.unitTmpOpts"
              />
            </BInputGroupAppend>

            <BFormCheckbox id="twin" class="mt-1 ml-1" v-model="tank.isTwin" switch inline>
              3D
            </BFormCheckbox>

          </BInputGroup>

        </div>
      </div>

    </BCard>



    <BRow class="mb-1">
      <BCol>
        <BInputGroup prepend="세척일" size="sm" >
          <BFormInput size="sm" id="cleanDate" type="date" v-model="tank.cleanDate"/>
        </BInputGroup>
      </BCol>
      <BCol>
        <BInputGroup prepend="보수일" size="sm" >
          <BFormInput size="sm" id="maDate" type="date" v-model="tank.maDate"/>
        </BInputGroup>
      </BCol>
    </BRow>

    <BRow class="mb-3">
      <BCol>
        <BBadge pill variant="info">등록</BBadge><span class="text-muted small"> {{`${toLocalTime(tank.createdAt)} | ${tank.regId?tank.regId:'NOBODY'}`}} </span>
      </BCol>
      <BCol class="text-right">
        <BBadge pill variant="primary">수정</BBadge><span class="text-muted small"> {{`${toLocalTime(tank.updatedAt)} | ${tank.updId?tank.updId:'NOBODY'}`}} </span>
      </BCol>
    </BRow>

    <BRow>
      <BCol>
        <b-button class="mt-1 mr-1" v-b-modal.tank-table-modal size="sm" variant="info">
          탱크테이블 <BBadge variant="light">{{ toComma(tank.tableCount || 0) }}</BBadge>
        </b-button>
        <b-button v-if="$store.state.user.role === 'SA'" class="mt-1" v-b-modal.raw-tank-modal size="sm">원시 데이터 보기</b-button>
      </BCol>
      <BCol>
        <BButton block variant="danger" @click="saveTank" :disabled="isUpdatingRecord">
          <BIconSave2Fill/> <strong>탱크정보 저장</strong>
          <div class="sk-plane bg-light float-left" style="height:25px;width:25px" v-if="isUpdatingRecord"></div>
          <div class="sk-swing float-right" style="height:25px;width:25px" v-if="isUpdatingRecord" >
            <div class="sk-swing-dot"></div>
            <div class="sk-swing-dot"></div>
          </div>
        </BButton>

      </BCol>
    </BRow>


    <BModal id="tank-table-modal"
            :title="`[${tank.tid}] ${tank.name} 탱크테이블`"
            size="xl"
            scrollable
            lazy
            ok-only
            ok-title="닫기"
            body-class="c-dark-theme"
            header-bg-variant="dark" header-text-variant="light"
            body-bg-variant="dark" body-text-variant="light"
            footer-bg-variant="dark" footer-text-variant="light">
      <TankTableList :tid="tank.tid" simple/>
    </BModal>

    <BModal id="notice-target-modal"
            :title="`[${tank.tid}] ${tank.name} 전송대상자`"
            size="lg"
            scrollable
            ok-only
            ok-title="닫기"
            header-bg-variant="dark" header-text-variant="light"
            body-bg-variant="dark" body-text-variant="light"
            footer-bg-variant="dark" footer-text-variant="light">
      <BTable small dark class="small" :items="noticeTargetRows" :fields="noticeTargetFields" show-empty empty-text="전송대상자가 없습니다"/>
      <div class="small text-muted">
        수신자 설정에서 사용중이고, 대상탱크가 전체이거나 이 탱크를 포함하며, 위 알림톡/SMS 스위치가 켜진 발송유형의 수신자입니다.
      </div>
    </BModal>

    <BModal id="raw-tank-modal"
            title="원시 데이터"
            size="xl"
            scrollable
            ok-only
            ok-title="닫기"
            header-bg-variant="dark" header-text-variant="light"
            body-bg-variant="dark" body-text-variant="light"
            footer-bg-variant="dark" footer-text-variant="light">
      <BTable small dark class="small" stacked :items="[tank]" :fields="tankFields">
        <template #cell(machine)="data">
          <pre class="text-light mb-0">{{ data.item.machine? data.item.machine._id +' | '+data.item.machine.mid+' | '+data.item.machine.name: '장비없음'}}</pre>
        </template>
        <template #cell(rowData)="data">
          <pre class="text-light mb-0">{{data.item}}</pre>
        </template>
      </BTable>
    </BModal>

  </div>

</template>


<style src="spinkit/spinkit.min.css"></style>

<script>
//-------------------------------------------------------------------------------------------------
import '@/common/HelperMixin';
import {
  apiCall,
  cloneVar, setAlarm, sleep,
} from '@/common/utils';
import con from '@/common/constants';

import moment from "moment";
import { Swatches } from 'vue-color'
import TankTableList from './TankTableList'

// const recvTypeMap = { manual: "매뉴얼", api: "API", socket: "소켓" };


//----------------------------------------------------------------------------------------------------
export default {
  name: "TankForm",
  components: {
    'swatches-picker': Swatches,
    TankTableList,
  },
  props: {
    tankId: { type: String, default: '' },
  },

  data () {
    return {
      con,
      leakMessage: '',
      // 누유체크 기준 시간(분). 목록에 없는 값은 '사용자입력'으로 직접 넣는다.
      leakIntPreset: 1,
      leakIntOptions: [
        {value: 1,        text: '1분'},
        {value: 5,        text: '5분'},
        {value: 10,       text: '10분'},
        {value: 30,       text: '30분'},
        {value: 60,       text: '1시간'},
        {value: 360,      text: '6시간'},
        {value: 720,      text: '12시간'},
        {value: 1440,     text: '24시간'},
        {value: 'custom', text: '사용자입력'},
      ],
      oilTempMap : {},
      maps: this.$store.state.codeMaps,
      opts: this.$store.state.codeOpts,
      machine: null,
      pickerShow: false,
      eventMap: this.$store.state.codeMaps['EVENT'],
      tank: null,
      originTank: null,

      arCodeOpts  : this.$store.state.area['opts'],

      tankFields: [
        { key:'rowData'                  , label: ''},
      ],

      isUpdatingRecord: false,
      noticeUsers: [], // 알림 수신자 전체 (전송대상자 수 계산용)
      noticeConfig: null, // 글로벌 알림전송설정 (atEnabled: 알림톡, enabled: SMS)
      noticeTargetFields: [
        { key: 'name',  label: '수신자명' },
        { key: 'hpNo',  label: '휴대폰번호' },
        { key: 'sType', label: '발송유형' },
        { key: 'tanks', label: '대상탱크' },
      ],

    }

  },
  async created(){
    console.log("--- TankForm --- created---------------------");
    try{

      await this.getOilTempMap();

      await this.getTankInfo();

      await this.getNoticeUsers();

    }catch(err){
      console.log(err);
    }
  },
  computed: {
    /** 글로벌 알림전송설정이 꺼진 채널 안내문 (모두 켜져 있으면 빈 문자열) */
    globalNoticeOffText(){
      if( !this.noticeConfig ) return '';
      const off = [];
      if( !this.noticeConfig.atEnabled ) off.push('알림톡');
      if( !this.noticeConfig.enabled ) off.push('SMS');
      return off.length ? `시스템 ${off.join('·')} OFF` : '';
    },

    /** 이 탱크의 경보 전송대상자 (수신자 사용중 + 대상탱크 매칭 + 탱크별 알림톡/SMS 스위치 반영) */
    noticeTargets(){
      if( !this.tank ) return [];
      const nt = (this.tank.alarm && this.tank.alarm.notice) ? this.tank.alarm.notice : { at: true, sms: true };
      return this.noticeUsers.filter(u => {
        if( !u.enabled ) return false;
        if( u.sType === 'AT' && !nt.at ) return false;
        if( u.sType === 'SMS' && !nt.sms ) return false;
        const tids = u.tids || [];
        return !tids.length || tids.includes(this.tank.tid);
      });
    },

    /** 전송대상자 모달 테이블 행 (마스킹 표시) */
    noticeTargetRows(){
      return this.noticeTargets.map(u => ({
        name : this.toNameMask(u.name),
        hpNo : this.toPhoneMask(u.hpNo),
        sType: (u.sType === 'AT') ? '알림톡' : 'SMS',
        tanks: (!u.tids || !u.tids.length) ? '전체 탱크' : u.tids.map(t => this.tankName(t)).join(', '),
      }));
    },

    /** 안전재고량은 0 이상 실저장용량 이하여야 한다 */
    isSafetyVolumeValid(){
      const v = Number(this.tank?.safetyVolume);
      if( !Number.isFinite(v) || v < 0 ) return false;
      const real = Number(this.tank?.tankRealVol);
      return !Number.isFinite(real) || real <= 0 || v <= real;
    },

  },

  mounted() {
    console.log("--- TankForm --- mounted---------------------");
    // below is not work!
  },

  methods: {
    /** 안전재고율(실용량대비) 입력 -> 안전재고량(L) 계산 (DB 저장값은 리터) */
    safetyRateChange(){
      const tank = this.tank;
      tank.safetyVolume = Math.round((Number(tank.safetyRate)||0) * tank.tankRealVol);
    },

    /** 알림 수신자 전체 및 글로벌 알림전송설정 조회 (전송대상자 표시용) */
    async getNoticeUsers(){
      try{
        const r = await apiCall('get', `/api/notice/user`);
        if( r.code === 200 ) this.noticeUsers = r.result;
        const rc = await apiCall('get', `/api/notice`);
        if( rc.code === 200 && rc.result ) this.noticeConfig = rc.result;
      }catch(err){
        console.error('getNoticeUsers error', err);
      }
    },

    /** 탱크ID -> 탱크명 (매핑 없으면 tid 그대로) */
    tankName(tid){
      const t = (this.$store.state.tanks['map'] || {})[tid];
      return (t && t.name) ? t.name : tid;
    },

    tankVolumeChange(unit='gl'){
      // console.log("--- TankForm --- tankVolumeChange");
      const tank = this.tank;
      if(unit==='ltr'){
        tank.tankVolumeGl = Math.round(tank.tankVolume * con.LTR2GL );
      }else{
        tank.tankVolume = Math.round(tank.tankVolumeGl * con.GL2LTR );
      }

      tank.tankRealVol = tank.realVolRate * tank.tankVolume;
      // 실용량 변경 시 안전재고율을 유지하며 안전재고량(L) 재계산
      tank.safetyVolume = Math.round((Number(tank.safetyRate)||0) * tank.tankRealVol);
      tank.thresholds.overflowLtr1 = Math.round(tank.thresholds.overflowRate1 * tank.tankRealVol);
      tank.thresholds.overflowLtr2 = Math.round(tank.thresholds.overflowRate2 * tank.tankRealVol);
      tank.thresholds.underflowLtr1 = Math.round(tank.thresholds.underflowRate1 * tank.tankRealVol);
      tank.thresholds.underflowLtr2 = Math.round(tank.thresholds.underflowRate2 * tank.tankRealVol);

      tank.thresholds.overflowGl1 = Math.round( tank.thresholds.overflowLtr1 * con.LTR2GL );
      tank.thresholds.overflowGl2 = Math.round(tank.thresholds.overflowLtr2 * con.LTR2GL);
      tank.thresholds.underflowGl1 = Math.round(tank.thresholds.underflowLtr1 * con.LTR2GL);
      tank.thresholds.underflowGl2 = Math.round(tank.thresholds.underflowLtr2 * con.LTR2GL);
    },

    /**
     * 저장된 기준 시간(분)을 셀렉트 상태에 맞춘다.
     * 구 설정(leakIntSecs, 초)만 있는 탱크는 분으로 올려 받는다.
     *
     * 대상 탱크를 인자로 받는다. setTankThresholds() 는 this.tank 에 할당되기 전의
     * 응답 객체를 다루므로 this.tank 를 읽으면 null 이다.
     * @param tank 대상 탱크. 생략하면 현재 편집중인 탱크
     */
    syncLeakIntPreset(tank){
      const t = tank || this.tank;
      if(!t || !t.thresholds) return;

      const th = t.thresholds;
      if(!(th.leakIntMins > 0)){
        th.leakIntMins = (th.leakIntSecs > 0) ? Math.max(1, Math.round(th.leakIntSecs / 60)) : 1;
      }
      const hit = this.leakIntOptions.find(o => o.value === th.leakIntMins);
      this.leakIntPreset = hit ? hit.value : 'custom';
    },

    leakIntPresetChange(v){
      // '사용자입력'은 현재 값을 그대로 두고 입력칸만 연다
      if(v !== 'custom') this.tank.thresholds.leakIntMins = v;
      this.leakRateChange();
    },

    leakRateChange(){
      let t = this.tank;
      if(!t || !t.thresholds) return;

      const mins = t.thresholds.leakIntMins;
      const hit = this.leakIntOptions.find(o => o.value === mins);
      const label = hit ? hit.text : `${mins}분`;
      this.$bvToast.show('leakHelpToast');
      this.leakMessage = `${label} 이전 측정치와 현재 측정치를 온도환산재고 기준으로 비교하여 ${(t.tankRealVol * t.thresholds.leakRate).toFixed(0)} L 이상 감소한 경우 누유로 설정됩니다. 입출고 작업이 있었다면 작업 종료 시점부터 다시 셉니다.`;
    },
    setFromDate(){
      this.toDate =  moment(this.fromDate).add(1,"month").subtract(1,'day').format("YYYY-MM-DD");
    },

    underflowRateChange(step){
      if(step===1){
        this.tank.thresholds.underflowGl1 = Math.round(this.tank.thresholds.underflowRate1 * this.tank.tankRealVol * con.LTR2GL)
        this.tank.thresholds.underflowLtr1 = Math.round(this.tank.thresholds.underflowRate1 * this.tank.tankRealVol )
      }else if(step===2){
        this.tank.thresholds.underflowGl2 = Math.round(this.tank.thresholds.underflowRate2 * this.tank.tankRealVol * con.LTR2GL)
        this.tank.thresholds.underflowLtr2 = Math.round(this.tank.thresholds.underflowRate2 * this.tank.tankRealVol )
      }
    },

    underflowVolumeChange(step){
      // console.debug( "underflowVolumeChange", step );
      const {thresholds} = this.tank;
      if(step===1){
        thresholds.underflowRate1 = thresholds.underflowGl1 / (this.tank.tankRealVol * con.LTR2GL);
        thresholds.underflowLtr1 = Math.round( thresholds.underflowGl1 * con.LTR2GL );

      }else if(step===2){
        thresholds.underflowRate2 = thresholds.underflowGl2 / (this.tank.tankRealVol * con.LTR2GL);
        thresholds.underflowLtr2 = Math.round( thresholds.underflowGl2 * con.LTR2GL );
      }
    },

    overflowRateChange(step){
      if(step===1){
        this.tank.thresholds.overflowGl1 = Number((this.tank.thresholds.overflowRate1 * this.tank.tankRealVol * con.LTR2GL).toFixed(3));
        this.tank.thresholds.overflowLtr1 = Math.round(this.tank.thresholds.overflowRate1 * this.tank.tankRealVol );
      }else if(step===2){
        this.tank.thresholds.overflowGl2 = Number( (this.tank.thresholds.overflowRate2 * this.tank.tankRealVol * con.LTR2GL).toFixed(3) );
        this.tank.thresholds.overflowLtr2 = Math.round(this.tank.thresholds.overflowRate2 * this.tank.tankRealVol );
      }
    },

    overflowVolumeChange(step){
      // console.debug( "underflowVolumeChange", step );
      const {thresholds} = this.tank;
      if(step===1){
        thresholds.overflowRate1 = Number( (thresholds.overflowGl1 / (this.tank.tankRealVol * con.LTR2GL)).toFixed(4) );
        thresholds.overflowLtr1 = Math.round( thresholds.overflowGl1 * con.LTR2GL );

      }else if(step===2){
        thresholds.overflowRate2 = Number( (thresholds.overflowGl2 / (this.tank.tankRealVol * con.LTR2GL)).toFixed(4) );
        thresholds.overflowLtr2 = Math.round( thresholds.overflowGl2 * con.LTR2GL );
      }
    },



    async getOilTempMap(){
      try{
        this.oilTempMap = {};
        const {result} = await apiCall('get', `/api/oil`);
        if( result.length ){
          for( let r of result ) this.oilTempMap[r.code] = r.oilTempGroup;
        }

      }catch(err){
        console.error("getOilTempMap error", err);
      }

    },

    setOilTempGroup(){
      if( this.tank.oilCode ) this.tank.oilTempGroup = this.oilTempMap[this.tank.oilCode];

      // console.log( 'setOilTempGroup --->', this.tank.oilTempGroup );
    },

    async getTankInfo(){
      try{
        // console.log("getTankInfo tank._id --------->", this.tankId);
        const rs = await apiCall('get', `/api/tank/${this.tankId}`);
        const tank = rs.result;

        if( tank ) {
          this.setTankThresholds(tank);
          // 알림톡/SMS 탱크별 전송 스위치 기본값 (구 데이터 호환)
          if( !tank.alarm.notice ) tank.alarm.notice = { at: true, sms: true };
        }

        this.originTank = cloneVar(tank);
        this.tank = tank;
        // console.log( 'getTankInfo ----------- result --->', tank );

      }catch(err){
        console.error("getTankInfo error", err);
      }
    },

    setTankThresholds(tank){
      tank['tankVolumeGl'] = Math.round(tank.tankVolume * con.LTR2GL);
      // 안전재고량 추가 이전에 등록된 탱크는 값이 없다. 숫자 입력에 undefined 가 들어가면 안 된다.
      tank['safetyVolume'] = Number(tank.safetyVolume) || 0;
      // 안전재고율(실용량대비, UI 전용) 초기화. DB 저장값은 리터(safetyVolume)
      tank['safetyRate'] = (tank.tankRealVol > 0) ? +(tank.safetyVolume / tank.tankRealVol).toFixed(4) : 0;
      tank.thresholds['overflowGl1'] = Math.round(tank.thresholds.overflowLtr1 * con.LTR2GL);
      tank.thresholds['overflowGl2'] = Math.round(tank.thresholds.overflowLtr2 * con.LTR2GL);
      tank.thresholds['underflowGl1'] = Math.round(tank.thresholds.underflowLtr1 * con.LTR2GL);
      tank.thresholds['underflowGl2'] = Math.round(tank.thresholds.underflowLtr2 * con.LTR2GL);
      this.syncLeakIntPreset(tank); // 저장값을 누유 기준시간 셀렉트에 반영
    },

    async applyTankAlarm(){
      try{
        const param = {};
        param['tid'] = this.tank.tid;
        param['alarm'] = this.tank.alarm;
        param['display'] = this.tank.display;
        let msg = '';
        param.alarm.events.map(e=>{
          if( !e.enabled ) msg =  msg + this.eventMap[e.code] + ','
        })

        if(msg){
          msg = msg.slice(0,-1) + ' 임계치 체크가 중단되며 로그를 저장하지 않습니다.'
          if(!await this.confirmModal(msg + '적용 하시겠습니까?', '경보설정 적용확인')){
            return;
          }
        }

        if( !param.display ){
          if(!await this.confirmModal('탱크 모니터링을 중단합니다.', '경보설정 적용확인'))
          return;
        }else if( !param.alarm.enabled ){
          if(!await this.confirmModal('탱크 경보알림을 중단합니다.', '경보설정 적용확인'))
            return;
        }


        const rs = await apiCall("PUT", `/api/tank/alarm/${this.tank._id}`, param );
        await this.toastResult(rs, `경보설정 적용`);
      }catch(err){
        console.error(err);
      }
    },

    async savePosition(){
      try{
        const position = this.tank.position;
        const coordinates = this.tank.location.coordinates;
        const param = {
          coordinates,
          position
        }
        const rs = await apiCall("PUT", `/api/tank/position/${this.tank._id}`, param );
        await this.toastResult(rs, `위치정보 수정`);
      }catch(err){
        console.error(err);
      }
    },


    async saveTank(){
      let rs = { code: 999, message: '', result: false };

      try{
        const tank = this.tank;
        if(!tank.eventEnabled){
          if(!await this.confirmModal('임계치 모니터링이 해제되어 경보기능이 중단됩니다. 진행 하시겠습니까?')){
            tank.eventEnabled = true;
            return;
          }
        }

        this.isUpdatingRecord = true;
        // const row = this.$refs['excelGrid'].currentRecord;


        const {thresholds} = tank;
        thresholds.overflowLtr1 = Math.round( thresholds.overflowGl1 * con.GL2LTR );
        thresholds.overflowLtr2 = Math.round( thresholds.overflowGl2 * con.GL2LTR );
        thresholds.unferflowLtr1 = Math.round( thresholds.underflowGl1 * con.GL2LTR );
        thresholds.unferflowLtr2 = Math.round( thresholds.underflowGl2 * con.GL2LTR );

        delete tank.machine; // 업데이트 금지 MachineForm 장비연결 버튼으로 처리
        delete tank.mid; // 업데이트 금지  MachineForm 정비연결 버튼으로 처리
        // console.log( 'param --->', tank );

        rs = await apiCall("PUT", `/api/tank/${tank._id}`, tank);
        // console.log( 'result ----------->', rs );
        this.tank = rs.result;
        if( !this.tank.alarm.notice ) this.tank.alarm.notice = { at: true, sms: true };

        this.setTankThresholds(this.tank);

        await setAlarm();

        await sleep(500);
        this.isUpdatingRecord = false;
        await this.toastResult(rs, `탱크정보 수정`);


      }catch(err){
        await this.alertDanger(err.message, rs.code, 'danger');
        console.error( err );
      }
    },

  }
}
</script>

<style scoped>
/* 경보임계치 설정 카드 좌측 항목 배지 폰트 확대 */
.thres-badge {
  font-size: 85%;
}
</style>

